import * as Sentry from "@sentry/react";

export class SentryHelper {
    static apiCatch = (error) => {
        const response = {
            ...error?.response
        }

        if(response?.config?.headers?.Authorization) {
            delete response.config.headers.Authorization;
        }

        const stringifiedErrorResponse = JSON
            .stringify(response)

        // configureScope was removed in @sentry/react v8, use getCurrentScope instead
        Sentry.getCurrentScope()
            .setLevel('error')
            // TODO: Add user data
            //.setUser({email: state?.userDataState?.user?.email, id: `${state?.userDataState?.user?.id}`})
            //.setExtra("store", stringifiedState)
            .setExtra("errorResponse", stringifiedErrorResponse);
        // Sentry.showReportDialog(); - If you want get users feedback on error
        return Sentry.captureException(error);
    };
}